import React from 'react';
import PropTypes from 'prop-types';

import ResumeGraphic from '@zr/jobseeker-public/apps/jobseeker-screens/components/Screens/ScreenTypes/UploadResumeOrCreateProfile/ResumeGraphic';

import {
  STRING_PARSE_INTRO,
  STRING_PARSE_GET_STARTED,
} from './labels';

import './ParseEntryCorrectionIntro.less';

const getDescString = (companyName) => (
  `We are building a profile using information from your resume. Your profile will be viewed by ${companyName} and will be sent with your application. Please add any missing information.`
);

export function ParseEntryCorrectionIntro({
  companyName,
  headerPriority,
  onDone,
}) {
  const HTag = `h${headerPriority}`;
  return (
    <div className="ParseEntryCorrectionInfo">
      <div className="resume_graphic_wrapper">
        <ResumeGraphic />
      </div>
      <HTag className="intro_title">{STRING_PARSE_INTRO}</HTag>
      {/* TODO: when we put this parse resume code outside of apply flows, we need different text without a company name */}
      {companyName && (
        <div className="intro_description_wrapper">
          <p className="intro_description">{getDescString(companyName)}</p>
        </div>
      )}
      <button
        className="get_started_button"
        onClick={onDone}
        type="button"
      >
        {STRING_PARSE_GET_STARTED}
      </button>
    </div>
  );
}

ParseEntryCorrectionIntro.propTypes = {
  companyName: PropTypes.string,
  headerPriority: PropTypes.number,
  onDone: PropTypes.func.isRequired,
};

ParseEntryCorrectionIntro.defaultProps = {
  companyName: null,
  headerPriority: 4,
};

export default ParseEntryCorrectionIntro;
